import { Icon, Tag } from '@core/ui-elements'
import dayjs from 'dayjs'
import { FC } from 'react'
import { IoSparklesSharp } from 'react-icons/io5'
import { MdCircle } from 'react-icons/md'

export const SuperDakiTag: FC<{
  bgColor?: 'white' | 'blue.100'
  showTag?: boolean
  showIcon?: boolean
  size?: 'xs' | 'sm' | 'md' | 'lg'
  etaMin?: string | Date
  etaMax?: string | Date
}> = ({
  bgColor = 'white',
  showTag = false,
  showIcon = true,
  size = 'sm',
  etaMax,
  etaMin,
}) => {
  if (!showTag) return null

  return (
    <Tag backgroundColor={bgColor} size={size}>
      {showIcon ? (
        <Icon
          as={IoSparklesSharp}
          color={bgColor === 'white' ? 'blue.600' : undefined}
          marginRight={'0.25rem'}
        />
      ) : null}
      SuperDaki
      {etaMin && etaMax ? (
        <>
          {' '}
          <Icon as={MdCircle} boxSize="0.375rem" />{' '}
          {dayjs(etaMin).format('HH:mm')} a {dayjs(etaMax).format('HH:mm')}
        </>
      ) : null}
    </Tag>
  )
}
